import { createContext } from 'react';

export const AppSecretsContext = createContext<Record<string, string>>({});
